import React from 'react';
import { render } from 'react-dom';
import { cls } from '../../packages/components';
import { ColoredButton } from '../../packages/components/lib/ColoredButton'
import { Tab } from '../../packages/components/lib/Keyboard/Tab'
import Translator from '../../requests/apa/Translator';
import "./_styles.scss";

const COLORED_BAR_PRIMARY = 'normal';
const COLORED_BAR_TABS = 'tabs';

//TODO agregar llaves de metadata
const COLORED_BAR_BUTTONS = [
    {
        color: "green",
        metadataKeyLabel: '_',
        metadataLabelDefault: 'SALIR'
    },
    {
        color: "blue",
        metadataKeyLabel: '_',
        metadataLabelDefault: 'MÁS OPCIONES'
    },
    {
        color: "yellow",
        metadataKeyLabel: '_',
        metadataLabelDefault: 'GUÍA COMPLETA'
    },
    {
        color: "red",
        metadataKeyLabel: '_',
        metadataLabelDefault: 'MOSTRAR REPRODUCTOR'
    }
];

const renderWithTabs = ( type, renderComponent, props) => {
    if(type === COLORED_BAR_PRIMARY || type === COLORED_BAR_TABS)
        return typeof renderComponent === 'function' && renderComponent(props);
        return typeof renderComponent === 'function' && (
            <Tab {...props}>
                {
                    renderComponent({})
                }
            </Tab>
        );
}

const ColoredBar = ({ type = COLORED_BAR_PRIMARY, buttons = COLORED_BAR_BUTTONS, getNavigation = null, className }) => {
    return(
        <div className={cls("colored-bar", className)}>
            <div className={`colored-bar-${type}`}>
                {
                    buttons.map((button, idx, items) =>{
                        const props = {
                            className: button.buttonClassName || '',
                            onClick: button.onClick || null,
                            navigation: getNavigation ? getNavigation(idx, items) : null,
                        }
                        if(button.id) {
                            props.id = button.id
                        }
                        return renderWithTabs(type, (props)=> {
                            return(
                                    <ColoredButton
                                        {...props}
                                        color={button.color}>
                                            { Translator.get(button.metadataKeyLabel, button.metadataLabelDefault)}
                                    </ColoredButton>
                            )
                        }, props)
                    })
                }
            </div>
        </div>
    )
}

export default ColoredBar;



// WEBPACK FOOTER //
// ./src/components/ColoredBar/index.jsx